import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient,HttpParams } from '@angular/common/http';
import { Procedure } from '../models/procedure.model';


@Injectable()
export class ProcedureService {
  readonly apiServer:string;

    constructor(private _configService:ConfigService,private _http:HttpClient) {
      this.apiServer =this._configService.appSettings.webApiServer + "api/Procedure/";
    }
    async GetProcedureByName(procedure:string):Promise<Procedure> {
      const params=new HttpParams().set('Name',procedure); 
      return await this._http.get<Procedure>(`${this.apiServer}GetProcedureByName`,{params:params}).toPromise<Procedure>();
    }
    async GetProcedureByDescription(description:string) :Promise<Procedure>{
      const params=new HttpParams().set('Description',description);
      return await this._http.get<Procedure>(`${this.apiServer}GetProcedureByDescription`,{params:params}).toPromise<Procedure>();
    }
    async GetProcedureById(id:number):Promise<Procedure>{
      const params=new HttpParams().set('Id',id.toString());
      return await this._http.get<Procedure>(`${this.apiServer}GetProcedureById`,{params:params}).toPromise<Procedure>();

    }
    async GetProcedures(mostRecent: boolean, offset: number, totalItems: number, searchText: string, orderBy: string, direction: string):Promise<Procedure[]>{
      const params = new HttpParams()
      .set('mostRecent', mostRecent.toString())
      .set('offset', offset.toString())
      .set('totalItems', totalItems.toString())
      .set('searchText', searchText)
      .set('orderBy', orderBy)
      .set('direction', direction);
      return await this._http.get<Procedure[]>(`${this.apiServer}GetProcedures`, { params: params }).toPromise<Procedure[]>();
    }
    async RemoveProcedure(id:number):Promise<boolean>{
      const params=new HttpParams().set('Id',id.toString());
      return await this._http.delete<boolean>(`${this.apiServer}RemoveProcedure`, { params: params }).toPromise<boolean>();
    }
    async SetProcedure(procedure:Procedure):Promise<Procedure>{
      return await this._http.post<Procedure>(`${this.apiServer}SetProcedure`, JSON.stringify(procedure)).toPromise<Procedure>();
    }
}
